import Vue from 'vue'
import App from './App.vue'



/* 使用elementUI组件 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/* 引入路由，才能使用，记得在下面的new Vue里注册这个路由 */
import router from './routers.js'

import '@/assets/css/global.less' /*引入公共样式*/



/* 让vue使用elementUI */
Vue.use(ElementUI);
/* 让vue使用router */
Vue.use(router);

//跳转页面
Vue.prototype.openUrl = function (url) {
	this.$router.push(url)
}
 
//
Vue.prototype.returnStep = function (step) {
	if(!step)step=-1
	this.$router.go(step)
}
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
